module.exports = __webpack_public_path__ + "static/img/bg-id.a06a93e4.png";